import { PROJECT_CLASSIFICATION_TYPES } from '@adsk/alloy-provider';

export const TEMPLATE_ENTITLEMENTS_FIELDS =
  'name,accountName,defaultUrl,imageUrl,products,platform';
export const PROJECT_ENTITLEMENTS_FIELDS =
  'accountId,name,accountName,accountImageUrl,defaultUrl,classification,imageUrl,region,products,platform';
export const TEMPLATE_ENTITLEMENTS_CLASSIFICATION =
  PROJECT_CLASSIFICATION_TYPES.TEMPLATE;
export const PROJECT_ENTITLEMENTS_CLASSIFICATION = [
  PROJECT_CLASSIFICATION_TYPES.PRODUCTION,
  PROJECT_CLASSIFICATION_TYPES.SAMPLE,
].join(',');
export const TABS_NAMES = {
  ACCOUNTS: 'accounts',
  PROJECTS: 'projects',
  TEMPLATES: 'templates',
};

export const PROJECT_ENTITLEMENTS_LIMIT = 50;
